import React, { FC } from 'react';
import { Button, Heading, Icon, VStack } from '@chakra-ui/react';
import { AiOutlineDisconnect } from 'react-icons/ai';

const NotFoundPage: FC = () => {
  return (
    <VStack
      height='50vh'
      justify='center'
    >
      <Icon
        as={AiOutlineDisconnect}
        boxSize='16'
        color='gray.500'
      />
      <Heading
        color='gray.500'
        fontWeight='bold'
        size='md'
      >
        Página no encontrada
      </Heading>
      <Button
        colorScheme='brand'
        onClick={() => window.location.href = '/'}
      >
        Ir a la página principal
      </Button>
    </VStack>
  );
};

export default NotFoundPage;
